import { render, staticRenderFns } from "./article.vue?vue&type=template&id=ca126c74&lang=pug&"
import script from "./article.vue?vue&type=script&lang=ts&"
export * from "./article.vue?vue&type=script&lang=ts&"
import style0 from "./article.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports